import React from "react";
import { Animated,  TextInput, View } from "react-native";
import CText from "./CText";
import { CreateResponsiveStyle, DEVICE_SIZES} from "rn-responsive-styles";
import { COLORS, FONTS } from "../constant";



export default function CInput(otherProps){
  const styles = useStyles();        

  const handleValidation = (value) => {
    const { pattern } = otherProps;
    if (!pattern) return true;
    // string pattern, one validation rule
    if (typeof pattern === 'string') {
      const condition = new RegExp(pattern, 'g');
      return condition.test(value.toLowerCase());
    }
    // array patterns, multiple validation rules
    if (typeof pattern === 'object') {
      const conditions = pattern.map(rule => new RegExp(rule, 'g'));
      return conditions.map(condition => condition.test(value)); 
    }
  }

  const onChange = (value) => {
    let mutableValue = value;
    const { onChangeText, onValidation, inputType } = otherProps;
    if (inputType) {
      if (inputType === "numeric") {
        mutableValue = mutableValue.replace(/[^\d]/g, '');
      }
      if(inputType === "alpha-numeric"){
        mutableValue = mutableValue.replace(/[\W_]+/g,'');
      }
      if(inputType === "alpha"){
        mutableValue = mutableValue.replace(/[^a-z]/ig, '');
      }
    }   
    const isValid = handleValidation(mutableValue);
    onValidation && onValidation(isValid);  
    onChangeText && onChangeText(mutableValue);
  }

    return (
      <View style={styles.inputWrapper}>
        <CText.inputTopLabel>
          {otherProps.label}
          {
            otherProps.mandatoryField
            ? <Animated.Text
            style={[
              styles.inlineError,
              { color: "#f00", fontSize: 15, fontWeight: "500" },
            ]}
          >
            {" *"}
          </Animated.Text>
          : null
          }
           </CText.inputTopLabel>
        <TextInput
          {...otherProps}
          onChangeText={value => onChange(value)}
          style={[styles.inputStyle,otherProps.style]}
          editable = {otherProps.disable}
          placeholder={otherProps.placeHolder}
          placeholderTextColor={"gray"}
        />
        <CText.inputError>{otherProps.errorText}</CText.inputError>
      </View>
    );

};
const useStyles = CreateResponsiveStyle(

  {
    inputStyle: {
      width: 240,
      height: 36.5,
      borderRadius: 8.3,
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: COLORS.white1,
      fontFamily: FONTS.InterMedium,
      fontSize: 16,
      lineHeight: 18,
      letterSpacing: 0.1,
      textAlign: "left",
      color: COLORS.darkBlack,
      paddingLeft: 17,
    },
    inputDisable: { backgroundColor: "#f8f8f8" },

    inputViewStyle: {
      flexDirection: "row",
      marginVertical: 10,
    },
    inputWrapper: {
      gap: 5,
    },
    inlineError: {
      fontFamily: "Inter",
      fontSize: 12,
      color: "#db1a1a",
      marginTop: 3,
      marginLeft: 0,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
      inputStyle: {
        width: 264,
      },
    },
  }
);

